/* eslint-disable import/first,quotes */
// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ApologyController from "./apology_controller"
application.register("apology", ApologyController)

import AutoRemoveController from "./auto_remove_controller"
application.register("auto-remove", AutoRemoveController)

import AutoShowController from "./auto_show_controller"
application.register("auto-show", AutoShowController)

import CheckAllController from "./check_all_controller"
application.register("check-all", CheckAllController)

import ConfirmedDownloadController from "./confirmed_download_controller"
application.register("confirmed-download", ConfirmedDownloadController)

import CopilotTenantInputController from "./copilot_tenant_input_controller"
application.register("copilot-tenant-input", CopilotTenantInputController)

import DynamicTextFieldsController from "./dynamic_text_fields_controller"
application.register("dynamic-text-fields", DynamicTextFieldsController)

import EditorController from "./editor_controller"
application.register("editor", EditorController)

import FailedPaymentModeSwitchController from "./failed_payment_mode_switch_controller"
application.register("failed-payment-mode-switch", FailedPaymentModeSwitchController)

import FormController from "./form_controller"
application.register("form", FormController)

import LabeledRangeController from "./labeled_range_controller"
application.register("labeled-range", LabeledRangeController)

import PlannedChangeFieldController from "./planned_change_field_controller"
application.register("planned-change-field", PlannedChangeFieldController)

import PlannedChangeProductsController from "./planned_change_products_controller"
application.register("planned-change-products", PlannedChangeProductsController)

import PurchasesController from "./purchases_controller"
application.register("purchases", PurchasesController)

import ShowHideLinkController from "./show_hide_link_controller"
application.register("show-hide-link", ShowHideLinkController)

import TomselectController from "./tomselect_controller"
application.register("tomselect", TomselectController)

import WritingNewFormController from "./writing_new_form_controller"
application.register("writing-new-form", WritingNewFormController)
